import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
export default function MergeUnionCss(defaultStyles, localStyles, styleInfo) {
  var cloneDefaultStyles = _Object$assign({}, defaultStyles),
    stylekeys = _Object$keys(styleInfo);
  _forEachInstanceProperty(stylekeys).call(stylekeys, function (key, index) {
    var _context;
    var styleDefaultFormatName = cloneDefaultStyles[key];
    _forEachInstanceProperty(_context = styleInfo[key]).call(_context, function (localKey, index) {
      var styleLocalFormatName = localStyles[localKey];
      if (typeof styleLocalFormatName !== 'undefined') {
        styleDefaultFormatName += " ".concat(styleLocalFormatName);
      }
    });
    cloneDefaultStyles[key] = styleDefaultFormatName;
  });
  return cloneDefaultStyles;
}